import React, { useEffect, useState } from 'react';
import { Box, Grid, Button } from '@mui/material';
import AxiosInstance from '../../../server/AxioInstance';
import TableComponent from '../../common/table/Table';
import ApproveButton from '../../common/approveBotton/ApproveBotton';


const columns = [
  { id: 'sector', label: 'Setor', align: 'left' },
  { id: 'subSector', label: 'Sub-Setor', align: 'left' },
  { id: 'data', label: 'Data', align: 'center' },
  { id: 'acao', label: 'Ação', align: 'center' },
];

const LinkSectorSubSectorConsult = ({ handleChangeComponent }) => {
  const [rows, setRows] = useState([]);

  const handleLinkConsultSector = async () => {
    try {
      const result = await AxiosInstance.get('/sector/cosnult-link-sector');
      const temp = result?.data?.rows?.map((item) => ({
        ...item,
        ativo: item.active ? 'ATIVADO' : 'DESATIVADO',
        acao: (
          <ApproveButton
            url='/sector/activator-link-sector-subsector'
            item={item}
            handleChangeComponent={handleChangeComponent}
            handleCosnult={handleLinkConsultSector}
            edit={false}
          />
        ),
      }));
      setRows(temp);
    } catch (error) {
      console.error('Erro ao consultar dados:', error);
      // Tratar o erro conforme necessário (ex: exibir uma mensagem de erro)
    }
  };

  useEffect(() => {
    handleLinkConsultSector();
  }, []);

  return (
    <Box m={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={4}>
          <Button
            variant='contained'
            fullWidth
            onClick={() => handleChangeComponent('Criar vinculo', 'create')}
          >
            cadastrar
          </Button>
        </Grid>
        <Grid item xs={12} md={12} xl={12}>
          <TableComponent columns={columns} rows={rows} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LinkSectorSubSectorConsult;
